<div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Reporting to Branch Head
        </div>
        <div class="card-body p-1">    
            <div class="row m-1">
                <div class="col-md-1 px-1">
                    <label class="Label">Branch:</label>
                </div>
                <div class="col-md-4 px-1">
                    <ng-select name="branch" [items]="BranchMaster" bindLabel="BranchName" bindValue="BranchMasterID"
                        [(ngModel)]="BranchId" (change)=" onSelectChange('Branch'); ComboLoad('Client')" placeholder="Select Branch">
                        <ng-option *ngFor="let segment of BranchMaster" [value]="segment.BranchMasterID">
                            {{ segment.BranchName }}
                        </ng-option>
                    </ng-select>
                </div>
                <div class="col-md-2 px-1">
                    <button class="btn  btn-primary" name="search" (click)="Search()">
                        <i class="bi bi-search" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Search':'Loading...'}}
                    </button>
                </div>
            </div>
            
           
            <div>
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col" style="width: 3%;">#</th>
                        <th scope="col" style="display: none;"> Branch Master ID</th>
                        <th scope="col"  style="width: 10px;"> Branch Code</th>
                        <th scope="col"> Branch Name</th>
                        <th scope="col" class="narrow-column">Reporting Approval</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let site of BranchDataLoad; let i = index">
                        <th scope="row">{{ i + 1 }}</th>
                        <td style="display: none;">{{ site['BranchMasterID'] }}</td>
                        <td  style="width: 10px;">{{ site['BranchCode'] }}</td>
                        <td>{{ site['BranchName'] }}</td>
                        <td class="narrow-column">
                            <select class="form-select narrow-dropdown ng-select" name="reportmanager1" [(ngModel)]="site.ApproverUserMasterId">
                                <option [value]="0">Select</option>
                                <option *ngFor="let manager of UserLoad" [value]="manager.UserMasterId">
                                    {{ manager.UserName }}
                                </option>
                            </select>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col">
                    <div class="row">
                    </div>
                    <div class="row">
                    </div>
                </div>
                <div class="col-auto">
                    <button class="btn btn-primary" name="save" (click)="save()" *ngIf="this.common.PageRight.IsEdit">
                        <i class="bi bi-save" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Save':'Loading...'}}
                    </button>
                </div>
            </div>
        </div>
    </div> 
</div>